
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import CustomConfirmDialog from "@/components/primevueCustom/ConfirmDialog.vue";
import { useConfirm } from "primevue/useconfirm";

export default defineComponent({
  props: {
    accept: { type: Function, default: () => {}, required: false },
    reject: { type: Function, default: () => {}, required: false },
  },
  setup(props) {
    const confirm = useConfirm();

    const { t } = useI18n();

    const isConfirmButton = () => {
      confirm.require({
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "확인",
        group: "confirm",
        accept: () => {
          //goBack();
          props.accept();
        },
        reject: () => {
          //goBack();
          props.reject();
        },
      });
    };

    return {
      isConfirmButton, t
    };
  },
  components: {
    CustomConfirmDialog,
  },
});
